import { Directive, Input, OnInit, OnDestroy } from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material';
import { FormControlName } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
	// tslint:disable-next-line: directive-selector
	selector: 'mat-checkbox[trueFalseValue][formControlName]'
})
export class TrueFalseValueDirective implements OnInit, OnDestroy {
	// tslint:disable-next-line: no-input-rename
	@Input() falseValue: any = false;
	@Input() trueValue: any = true;
	subs: Subscription[] = [];
	constructor(private control: FormControlName, private matCheckBox: MatCheckbox) {}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
	ngOnInit() {
		this.matCheckBox.checked = this.trueValue === this.control.value ? true : false;
		this.subs.push(
			this.matCheckBox.change.subscribe((event: MatCheckboxChange) => {
				// patchValue ä¼å¼èµ·checkboxçcheckedå±æ§æ¹åï¼è¿ä¸ªé®é¢ä»¥åè§£å³
				this.control.control.patchValue(event.checked ? this.trueValue : this.falseValue);
				this.matCheckBox.checked = event.checked;
			})
		);
	}
}
